export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
		},
	],
	singular_model_name_spanish: 'Condicion',
	plural_model_name_spanish: 'Condicion',
	create_model_name_spanish: 'Nueva Condicion',
	text_delete: 'la',
}